/** 
 * 
 * This is the main entry point for `@serenity-is/corelib` package.
 * 
 * The types from this module are available by importing from "@serenity-is/corelib":
 * 
 * ```ts
 * import { EntityGrid } from "serenity-is/corelib"
 * 
 * export class MyGrid extends EntityGrid<MyRow, any> {
 * }
 * ```
 *   
 * > When using classic namespaces instead of the ESM modules, the types and functions in this module are directly available from the global `Serenity` namespace.
 * > e.g. `Serenity.EntityGrid`
 * @packageDocumentation
 * @module corelib
 */

export * from "./globals/select2-globals"
export * from "./globals/jquery-globals"
export * from "./globals/jquery.validation-globals"

export type { ServiceError, ServiceResponse, ServiceRequest, ServiceOptions, SaveRequest, SaveRequestWithAttachment, SaveResponse, SaveWithLocalizationRequest, DeleteRequest, DeleteResponse, UndeleteRequest, UndeleteResponse, ListRequest, ListResponse, RetrieveRequest, RetrieveResponse, RetrieveLocalizationRequest, RetrieveLocalizationResponse, PropertyItem, PropertyItemsData } from "@serenity-is/corelib/q";
export { ColumnSelection, RetrieveColumnSelection, SummaryType, Criteria } from "@serenity-is/corelib/q";

export * from "./interfaces";
export * from "./types";
export * from "./ui/datagrid/irowdefinition";
export * from "./ui/datagrid/islickformatter";
export * from "./decorators";
export * from "./ui/helpers/lazyloadhelper";
export * from "./ui/widgets/prefixedcontext";
export * from "./ui/widgets/widget";
export * from "./ui/widgets/jquerywidgetfn";
export * from "./ui/widgets/toolbar";
export * from "./ui/widgets/templatedwidget";
export * from "./ui/dialogs/templateddialog";
export * from "./ui/widgets/templatedpanel";
export * from "./ui/helpers/validationhelper";
export * from "./ui/editors/cascadedwidgetlink";
export * from "./ui/helpers/tabsextensions";
export * from "./ui/widgets/reflectionoptionssetter";
export * from "./ui/widgets/propertygrid";
export * from "./ui/widgets/propertypanel";
export * from "./ui/helpers/subdialoghelper";
export * from "./ui/dialogs/dialogextensions";
export * from "./ui/dialogs/propertydialog";
export * from "./ui/editors/editorutils";
export * from "./ui/editors/stringeditor";
export * from "./ui/editors/passwordeditor";
export * from "./ui/editors/textareaeditor";
export * from "./ui/editors/booleaneditor";
export * from "./ui/editors/decimaleditor";
export * from "./ui/editors/integereditor";
export * from "./ui/editors/dateeditor";
export * from "./ui/editors/datetimeeditor";
export * from "./ui/editors/timeeditor";
export * from "./ui/editors/emaileditor";
export * from "./ui/editors/emailaddresseditor";
export * from "./ui/editors/urleditor";
export * from "./ui/editors/radiobuttoneditor";
export * from "./ui/editors/select2editor";
export * from "./ui/editors/selecteditor";
export * from "./ui/editors/dateyeareditor";
export * from "./ui/editors/enumeditor";
export * from "./ui/editors/lookupeditor";
export * from "./ui/editors/servicelookupeditor";
export * from "./ui/editors/htmlcontenteditor";
export * from "./ui/editors/maskededitor";
export * from "./ui/editors/recaptcha";
export * from "./ui/helpers/uploadhelper";
export * from "./ui/editors/uploadeditors";
export * from "./ui/datagrid/quickfilter";
export * from "./ui/datagrid/quickfilterbar";
export * from "./ui/datagrid/quicksearchinput";
export * from "./ui/filtering/filteroperator";
export * from "./ui/filtering/filterline";
export * from "./ui/filtering/filterstore";
export * from "./ui/filtering/filtering";
export * from "./ui/filtering/filterwidgetbase";
export * from "./ui/filtering/filterpanel";
export * from "./ui/filtering/filterdialog";
export * from "./ui/filtering/filterdisplaybar";
export * from "./ui/datagrid/slickpager";
export * from "./ui/datagrid/idatagrid";
export * from "./ui/helpers/slickhelpers";
export * from "./ui/formatters/formatters";
export * from "./types/formattertyperegistry";
export * from "./ui/datagrid/datagrid";
export * from "./ui/datagrid/columnpickerdialog";
export * from "./ui/datagrid/treegridmixin";
export * from "./ui/editors/checktreeeditor";
export * from "./ui/datagrid/entitygrid";
export * from "./ui/dialogs/entitydialog";
export * from "./ui/widgets/jsx";

// legacy
export * from "./ui/widgets/reporting";
export * from "./ui/widgets/scriptcontext";
export * from "./interfaces/iasyncinit";
export * from "./ui/widgets/wx";
export * from "./ui/widgets/flexify";
export * from "./ui/widgets/googlemap";
export * from "./ui/editors/select2ajaxeditor";

export type Constructor<T> = new (...args: any[]) => T;